import gsap from "gsap"
import { resolveAndKillTweens } from "./utility"
import { betAmount, winningAmount } from "./networkService"
import { bigWin, megaWin, normalWin, ultraWin } from "./commendation"
import { COMMENDATION } from "./constants"

export async function fallAnimation(gameObj){
    gameObj.interactive = false
    const yPos = gameObj.finalY
    const duration = 1

    resolveAndKillTweens(gameObj)
    const tl = gsap.timeline()
    await tl.to(gameObj, {
        y: yPos,
        angle: 20,
        height: gameObj.height * 0.6,
        duration,
        ease: 'sine.in',
        onComplete: () => {
            gameObj.visible = false
            gameObj.y = gameObj.initialY
            gameObj.angle = gameObj.initialAngle
            gameObj.height = gameObj.initialHeight
        }
    })
}

export async function animateMultiplier(gameObj, cb){
    resolveAndKillTweens(gameObj)
    const tl = gsap.timeline()
    await tl.to(gameObj, {
        alpha: 1,
        duration: 0.2,
        ease: 'sine.in',
        onComplete: cb
    })
}

export let commendationType = COMMENDATION.NONE
export const setCommendationType = c => commendationType = c

export function showCommendation(){
    const betAmount = betAmount()
    const winningAmount = winningAmount()
    
    if(winningAmount >= 0  * betAmount && winningAmount < 5 * betAmount) {
        commendationType = COMMENDATION.NORMAL
        normalWin()
    }

    if(winningAmount >= 5 * betAmount && winningAmount < 20 * betAmount) {
        commendationType = COMMENDATION.BIG
        bigWin()
    } 
    
    if(winningAmount >=20 * betAmount && winningAmount < 100 * betAmount) {
        commendationType = COMMENDATION.MEGA
        megaWin()
    }
    
    if(winningAmount >= 100 * betAmount) {
        commendationType = COMMENDATION.ULTRA
        ultraWin()
    }


//     if (bet.winningAmount < 5 * bet.betAmount) {
//             typeOfWin = TYPE_OF_WIN.NORMAL_WIN
//         } else if (bet.winningAmount < 20 * bet.betAmount) {
//              typeOfWin = TYPE_OF_WIN.BIG_WIN
//         } else if (bet.winningAmount < 100 * bet.betAmount) {
//              typeOfWin = TYPE_OF_WIN.MEGA_WIN
//         } else {
//              typeOfWin = TYPE_OF_WIN.ULTRA_WIN
//         }

    // 'jackpot/major_in', 'jackpot/major_in_with_container', "jackpot/major_loop", "jackpot/major_out"
    // if(!gameAssets.background) gameAssets.background = new Spine(PIXI.Assets.get('jackpot').spineData)
    //   gameAssets.background.state.setAnimation(0, 'jackpot/major_in', true)   

}
